<template>
  <div
    ref="dynamicValidateForm"
    class="table-form"
    :class="{ 'disabled-table': formDisabledValue }"
    style="height: 100%"
  >
    <el-form :disabled="false">
      <ux-grid
        ref="plxTable"
        :data="currentData"
        :height="height"
        :beautifyTable="!table.props.border"
        widthResize
        highlight-current-row
        inverse-current-row
        header-drag-style
        :stripe="table.props.stripe"
        :border="table.props.border"
        rowKey
        columnKey
        resizable
        keep-source
        show-summary
        show-overflow="tooltip"
        :merge-cells="mergeCells"
        :summary-method="summaryMethod"
        :pagination-show="table.props.pagination"
        :total="form.length"
        :page-size="pagination.pageSize"
        :current-page="pagination.currentPage"
        show-header-overflow="ellipsis"
        :edit-config="
          !formDisabledValue
            ? { trigger: 'click', mode: 'cell', showIcon: false }
            : { showIcon: false }
        "
        :mouse-config="!formDisabledValue ? { selected: true } : {}"
        :keyboard-config="
          !formDisabledValue
            ? {
                isArrow: true,
                isDel: true,
                isEnter: true,
                isTab: true,
                isEdit: true,
              }
            : {}
        "
        @handlePageSize="handlePageSize"
      >
        <ux-table-column
          class-name="row-head"
          title="序号"
          type="index"
          align="center"
          width="78"
        >
          <template slot="header">
            <span :class="!formDisabledValue ? 'tool-text' : ''">序号</span>
            <div class="tool-bar" v-if="!formDisabledValue">
              <el-button
                style="font-size: 21px"
                size="large"
                type="text"
                @click="handleAddOneRow"
                icon="el-icon-circle-plus-outline"
              ></el-button>
            </div>
          </template>
          <template v-slot="scope">
            <div class="tool-bar" v-if="!formDisabledValue">
              <el-button
                class="sort"
                size="medium"
                type="text"
                icon="el-icon-rank"
              ></el-button>
              <el-button
                size="medium"
                type="text"
                @click="removeDomain(scope.row)"
                icon="el-icon-delete"
              ></el-button>
              <el-dropdown
                placement="bottom-start"
                trigger="click"
                @command="
                  handleAddRow($event, scope.row, index(scope.rowIndex) - 1)
                "
              >
                <el-button
                  size="medium"
                  type="text"
                  icon="el-icon-more"
                ></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="one">增加行</el-dropdown-item>
                  <el-dropdown-item command="any">增加多行</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div :class="!formDisabledValue ? 'tool-text' : ''">
              {{ index(scope.rowIndex) }}
            </div>
          </template>
        </ux-table-column>
        <template v-for="(item, index) in table.column">
          <ux-table-column
            :key="'column' + index"
            resizable
            show-overflow="tooltip"
            :visible="item.visible"
            :width="
              item.columnWidthType === 1
                ? item.columnWidth + '%'
                : item.columnWidthType === 2
                ? item.columnWidth + 'px'
                : 'auto'
            "
            :field="item.id + ''"
            :edit-render="
              editTypeMap.indexOf(item.componentType) !== -1
                ? { autofocus: autofocusMap(item) }
                : false
            "
          >
            <template slot="header">
              <div v-if="item.labelPosition !== 'none'">
                <span
                  style="color: #f56c6c"
                  v-if="item.rules.length > 0 && item.rules[0].required"
                  >*</span
                >
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <!-- 点击后显示控件 -->
            <template
              v-slot:edit="scope"
              v-if="editTypeMap.indexOf(item.componentType) !== -1"
            >
              <div>
                <el-form-item
                  :rules="item.rules"
                  :prop="table.id + '.' + scope.rowIndex + '.' + item.id"
                >
                  <FromItem
                    :fromType="0"
                    :item="item"
                    :rowIndex="scope.$rowIndex"
                    :formData="scope.row"
                    :lockedInfo="
                      lockedFields.find(
                        (field) =>
                          field.fieldId === item.id &&
                          (!field.triggerInfo ||
                            (field.triggerInfo &&
                              field.triggerInfo.top === scope.$rowIndex))
                      )
                    "
                    @handleUpdate="handleUpdate($event, scope.$rowIndex)"
                  />
                </el-form-item>
              </div>
            </template>
            <!-- 默认显示 -->
            <template v-slot="scope">
              <el-form-item
                :rules="item.rules"
                :prop="table.id + '.' + scope.rowIndex + '.' + item.id"
              >
                <!-- 显示数据 -->
                <span
                  v-if="editTypeMap.indexOf(item.componentType) !== -1"
                  class="my-input-sc"
                >
                  <!-- TODO formatter -->
                  <ColumnFormatter
                    :item="item"
                    :formData="scope.row"
                    v-if="connectFields[item.id]"
                    :class="'connect-link'"
                    @click.native.stop="connectLinkHandler(item,scope)
                    "
                  />
                  <ColumnFormatter v-else :item="item" :formData="scope.row" />
                  <!-- {{ scope.row[item.id] }} -->
                </span>
                <!-- 直接显示控件 -->
                <FromItem
                  v-else
                  :fromType="0"
                  :item="item"
                  :formData="scope.row"
                  :rowIndex="scope.$rowIndex"
                  :lockedInfo="
                    lockedFields.find(
                      (field) =>
                        field.fieldId === item.id &&
                        (!field.triggerInfo ||
                          (field.triggerInfo &&
                            field.triggerInfo.top === scope.$rowIndex))
                    )
                  "
                  @handleUpdate="handleUpdate($event, scope.$rowIndex)"
                />
              </el-form-item>
            </template>
          </ux-table-column>
        </template>
      </ux-grid>
    </el-form>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import ColumnFormatter from '@/views/Report/FormEditor/columnFormatter.vue'
import FromItem from '@/views/Report/FormEditor/formitem'
export default {
  name: 'tableForm',
  inject: ['formDisabled'],
  components: {
    FromItem,
    ColumnFormatter
  },
  props: {
    // 表单对象
    form: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 表格对象
    table: {
      type: Object,
      default: () => {
        return {
          column: []
        }
      }
    },
    connectFields: {
      type: Object,
      default() {
        return {}
      }
    },
    lockedFields: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    // 表单全局禁用状态
    formDisabledValue() {
      return this.formDisabled()
    },
    currentData() {
      // 分页
      if (this.table.props.pagination) {
        return this.form.slice((this.pagination.currentPage - 1) * this.pagination.pageSize, this.pagination.currentPage * this.pagination.pageSize)
      } else {
        return this.form
      }
    }
  },
  data() {
    return {
      sortable: undefined,
      total: 0,
      pagination: {
        pageSize: 10,
        currentPage: 1
      },
      mergeCells: [
        // row第几行，col第几列，rowspan行合并几行，colspan列合并几列
        // { row: 1, col: 1, rowspan: 3, colspan: 2 },
      ],
      editTypeMap: [
        'Input',
        'DatePicker',
        'IdentityCard',
        'Textarea',
        'Cascader',
        'Select',
        'InputNumber',
        'Slider',
        'Radio',
        'Checkbox',
        'Timepicker',
        'Amount',
        'Location'
      ],
      height: 0
    }
  },
  mounted() {
    this.init()
    console.log('table-mounted')
  },
  activated() {
    this.init()
    console.log('table-activated')
  },
  deactivated() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    // 增加行
    handleAddRow(val, row, index) {
      console.log(val, row, index)
      if (this.formDisabledValue) return
      switch (val) {
        case 'one':
          this.$emit('AddNewBlankRow', this.table.id, index)
          break
        case 'any':
          this.$prompt('请输入行数', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'number',
            inputValue: 1
          }).then(({ value }) => {
            this.$emit('AddNewBlankRow', this.table.id, index, value)
          })
          break
      }
    },
    rowDrag() {
      this.$nextTick(() => {
        const plxTable = this.$refs.plxTable
        const wrapperTr = plxTable.$el.querySelector('.body--wrapper .elx-table--body tbody')
        if (!wrapperTr) return
        // 关于sortable的配置https://www.cnblogs.com/xiangsj/p/6628003.html
        this.sortable = Sortable.create(wrapperTr, {
          handle: '.sort', // Drag handle selector within list items
          setData: function (dataTransfer) {
            dataTransfer.setData('Text', '')
            // to avoid Firefox bug
            // Detail see : https://github.com/RubaXa/Sortable/issues/1012
          },
          // 拖拽结束
          onEnd: ({ item, newIndex, oldIndex }) => {
            const currentNewIndex = this.table.props.pagination ? ((this.pagination.currentPage - 1) * this.pagination.pageSize + newIndex) : newIndex
            const currentOldIndex = this.table.props.pagination ? ((this.pagination.currentPage - 1) * this.pagination.pageSize + oldIndex) : oldIndex
            const currRow = this.form.splice(currentOldIndex, 1)[0]
            this.form.splice(currentNewIndex, 0, currRow)
          }
        })
      })
    },
    init() {
      this.pagination.currentPage = 1
      this.$nextTick(() => {
        this.height = this.$refs.dynamicValidateForm.offsetHeight
        this.pagination.pageSize = this.table.props.pageSize
        if (!this.formDisabledValue) {
          this.rowDrag()
        }
      })
    },
    // 序号
    index(rowIndex, rowIndex1) {
      return this.table.props.pagination
        ? rowIndex + 1 + (this.pagination.currentPage - 1) * this.pagination.pageSize
        : rowIndex + 1
    },
    // 翻页
    handlePageSize({ page, size }) {
      this.pagination.currentPage = page
      this.pagination.pageSize = size
    },
    // reload
    handleReloadData(data) {
      this.$nextTick(() => {
        this.$refs.plxTable.reloadData(data)
      })
    },
    // 更新数据
    handleUpdate(info, rowIndex) {
      this.$nextTick(() => {
        this.$refs.plxTable.updateFooter()
      })
      this.$emit('handleUpdate', info, rowIndex)
    },
    autofocusMap(item) {
      if (item.componentType === 'Textarea') {
        return '.el-textarea__inner'
      } else if (item.componentType === 'Slider') {
        return '.el-slider__button-wrapper'
      } else if (item.componentType === 'Timepicker') {
        if (item.props.isrange) {
          return '.el-range-input'
        } else {
          return '.el-input__inner'
        }
      } else if (item.componentType === 'DatePicker') {
        if (item.props.datetype.indexOf('range') !== -1) {
          return '.el-range-input'
        } else {
          return '.el-input__inner'
        }
      } else {
        return '.el-input__inner'
      }
    },
    // 统计
    summaryMethod({ columns, data }) {
      function cacl(arr, callback) {
        let ret
        for (let i = 0; i < arr.length; i++) {
          ret = callback(arr[i], ret)
        }
        return ret
      }
      // 合计算法
      Array.prototype.sum = function () {
        return cacl(this, function (item, sum) {
          if (typeof sum === 'undefined') {
            return item
          } else {
            return (sum += item)
          }
        })
      }
      // 平均值算法
      Array.prototype.avg = function () {
        if (this.length == 0) {
          return 0
        }
        return this.sum(this) / this.length
      }
      const means = [] // 合计
      const fenceSums = [] // 平均值
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          means.push('合计')
          fenceSums.push('平均值')
        } else {
          const values = data.map((item) => Number(item[column.property]))
          // 合计
          if (!values.every((value) => isNaN(value))) {
            means[columnIndex] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            // means[columnIndex] += ' 元'
          } else {
            means[columnIndex] = ''
          }
          // 平均值
          const precisions = []
          let notNumber = true
          values.forEach((value) => {
            if (!isNaN(value)) {
              notNumber = false
              const decimal = ('' + value).split('.')[1]
              precisions.push(decimal ? decimal.length : 0)
            }
          })
          if (!notNumber) {
            fenceSums[columnIndex] = values.avg()
          } else {
            fenceSums[columnIndex] = ''
          }
        }
      })
      // 返回一个二维数组的表尾合计
      const arr = []
      if (this.table.props.sum) {
        arr.push(means)
      }
      if (this.table.props.avg) {
        arr.push(fenceSums)
      }
      return arr
    },
    handleAddOneRow() {
      this.$emit('AddNewBlankRow', this.table.id)
    },

    random(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },
    removeDomain(item) {
      var index = this.form.indexOf(item)
      if (index !== -1) {
        this.form.splice(index, 1)
      }
      // this.handleReloadData(this.form)
    },
    connectLinkHandler(item,scope){
      this.$emit(
        'connectLinkClick',
        this.connectFields[item.id],
        (this.pagination.currentPage-1) * this.pagination.pageSize+scope.rowIndex
      )
    }
  }
}
</script>

<style lang="scss">
.elx-table .elx-body--column.col--ellipsis > .elx-cell,
.elx-table .elx-footer--column.col--ellipsis > .elx-cell,
.elx-table .elx-header--column.col--ellipsis > .elx-cell {
  max-height: 100px !important;
}
.table-form {
  position: relative;
  // 去除列表框线
  .WList {
    .el-input__inner {
      border: none;
      background-color: transparent;
      padding-left: 0;
    }
  }
  &.disabled-table {
    .elx-header--row .tool-bar {
      display: none !important;
    }
    .elx-header--row .tool-text {
      display: block !important;
    }
  }
  .el-progress,
  .el-rate {
    line-height: 14px !important;
  }
  &:hover .elx-header--row .tool-bar {
    display: block;
  }
  &:hover .elx-header--row .tool-text {
    display: none;
  }
  .elx-body--row:hover .tool-bar {
    display: block;
  }
  .elx-body--row:hover .tool-text {
    display: none;
  }
  .row--current .tool-bar {
    display: block;
  }
  .row--current .tool-text {
    display: none;
  }
  .el-textarea__inner {
    height: 40px !important;
  }

  .tool-bar {
    .el-button {
      padding: 0 0px;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .el-button + .el-button {
      margin-left: 3px;
    }
    display: none;
  }
  .WSign {
    height: 38px;
  }
  .WSingleImageUpload .imageBox,
  .WSingleImageUpload .placeholder {
    height: 38px;
    min-height: unset;
  }
  .file-item .float-tool-bar .el-button {
    margin: 0 0px;
    font-size: 12px;
  }
  .elx-cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  .row-head .sort {
    cursor: move;
  }
  .row-head.col--selected {
    box-shadow: none !important;
    background-color: transparent;
  }
}
.table-form .el-form-item {
  margin-bottom: 0 !important;
}
.table-form .cell {
  overflow-y: visible;
}
.table-form .el-switch {
  display: inline-block !important;
}
.plTableBox .myPagination {
  padding-top: 10px;
}
.plTableBox .elx-cell {
  /* height: 100%; */
}
.plTableBox .file-item,
.plTableBox .upload {
  width: 36px;
  height: 36px;
}
.plTableBox .WImageUpload .file-list {
  margin-bottom: -9px;
}
.plTableBox .WImageUpload .el-upload--picture-card,
.plTableBox .WImageUpload .el-upload-list--picture-card .el-upload-list__item {
  width: 45px;
  height: 45px;
  line-height: 50px;
}
.plTableBox .WImageUpload li,
.plTableBox .WImageUpload ul {
  height: 46px;
}
.plTableBox .el-switch {
  vertical-align: unset;
}
/* .plTableBox .el-input__inner {
  border: none;
  background: transparent;
} */
</style>
